<template>
  <div class="form">
    <div class="container">
      <div ref="form">
        <format-history
          v-if="permissionInfo.is_show_compare"
          :form-history-id="formHistoryId"
        />
        <div
          v-for="(modules, k) in formData"
          :id="`anchor_${modules.fieldkey}`"
          :key="k"
        >
          <!-- v-show="modules.fieldkey !== 'deal_info' || (modules.fieldkey === 'deal_info' && modules.show)" -->
          <div
            v-if="modules && modules.child && modules.child.length"
            class="module"
            :class="{ 'hide': hideModule(k) }"
          >
            <!-- 录入页接待信息启用，会有俩标题-隐藏来源的标题 -->
            <!-- receptionInfoChild.length为1 => 接待信息启用 -->
            <h2
              v-if="formData['from_info'] && modules.fieldkey === 'reception_info'"
              class="title"
            >
              {{ formData['from_info'].fieldname }}
            </h2>
            <h2
              v-else
              class="title"
              :class="{
                hide: modules.fieldkey === 'from_info' && receptionInfoChild.length
              }"
            >
              {{ modules.fieldname }}
            </h2>

            <!-- 信息来源部分特殊处理 start -->
            <template v-if="modules.fieldkey === 'from_info'">
              <my-item
                :ref="`item_${getId()}`"
                :value="currentFrom"
                :data="modules"
                @change="handleChangeFromSource"
              />

              <template v-if="currentFrom">
                <my-item
                  v-for="(item) in modules.childObj && modules.childObj[currentFrom] && modules.childObj[currentFrom].child"
                  :ref="`item_${getId()}`"
                  :key="item.fieldkey"
                  class="clearfix"
                  :data="item"
                  :modules-data="modules"
                  :current-from="currentFrom"
                />
              </template>
            </template>
            <!-- 信息来源部分特殊处理 end -->

            <!-- 人员信息 -->
            <template v-else-if="modules.fieldkey === 'info'">
              <member-edit
                ref="memberInfo"
                :data="modules"
                @change="handleChangeMember"
              />
            </template>

            <!-- 表单循环的主题部分 start -->
            <template v-else>
              <my-item
                v-for="(item) in modules.child"
                v-show="item.fieldtype || modules.fieldkey !== 'info'"
                :ref="`item_${getId()}`"
                :key="item.fieldkey"
                class="clearfix"
                :data="item"
                :modules-data="modules"
                @change="handleChangeItem($event, item)"
              />
            </template>
            <!-- 表单循环的主题部分 end -->
          </div>
        </div>

        <cube-form-group class="footer form-btn-box">
          <cube-button
            class="confirm-btn cube-btn-primary"
            @click="submitHandler"
          >
            {{ $t('message["21"]') }}
          </cube-button>
        </cube-form-group>
      </div>
    </div>

    <!-- 查重弹窗 -->
    <repeat-modal
      :visible.sync="showRepeatModal"
      :data="repeatData"
      :again-save-form="againSaveForm"
    />
    <gallery />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import eventBus from '@/lib/eventBus'
import inquiryFormMixin from '@/lib/inquiryFormMixin'
import { addInquiry } from '@/services/inqueryServices'
import MyItem from './Item'
import MemberEdit from './MemberEdit'
import RepeatModal from './../detail/modal/RepeatModal'
import FormatHistory from './FormatHistory'
import Gallery from '@/components/pc/Gallery'

let uniqueid = 1
export default {
  components: {
    MyItem,
    MemberEdit,
    RepeatModal,
    FormatHistory,
    Gallery
  },
  mixins: [inquiryFormMixin],
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      formData: Object.assign({}, this.data),
      options: {
        scrollToInvalidField: false,
        layout: 'standard' // classic fresh standard
      },
      currentFrom: null,
      showRepeatModal: false,
      repeatData: [],
      confirmLoading: false,
      errorElements: []
    }
  },
  computed: {
    ...mapState(['baseinfo']),
    ...mapState('inquery/detailData', ['joinTeamCascaderShow']),
    ...mapGetters('inquery/addConfigData', ['permissionInfo', 'isNeedAudit']),
    fromInfoChild () {
      const { from_info: fromInfo = {} } = this.formData || {}
      const { child = [] } = fromInfo
      return child
    },
    receptionInfoChild () {
      if (!this.formData) return
      let receptionInfo = this.formData['reception_info'] || {}
      return receptionInfo.child || []
    },
    baseInfo () {
      const { base_info: baseInfo = {} } = this.data || {}
      return baseInfo
    },
    formHistoryId () {
      return this.$route.query.form_history_id
    }
  },
  /* watch: {
    baseInfo: {
      handler (val) {
        if (val) {
          for (let item of val.child) {
            if (item.fieldkey === 'info_status') {
              this.setDealShow(item)
            }
          }
        }
      },
      immediate: true,
      deep: true
    }
  }, */
  async mounted () {
    // 设置来源的默认值和默认请求关联接口
    this.initFromInfo()
  },
  methods: {
    getId () {
      return uniqueid++
    },
    hideModule (k) {
      let { isDeal, isInvalid, isDiscard } = this
      return (k === 'deal_info' && !isDeal) || (k === 'invalid_info' && !isInvalid) || (k === 'discard_info' && !isDiscard)
    },

    /**
     * 切换成交显示隐藏
     */
    /* setDealShow (item) {
      if (item.fieldkey === 'info_status') {
        const dealStatusItem = item.options.find(option => option.name === this.$t('message["109"]')) || {}
        const res = dealStatusItem.id === item.fieldvalue
        if (res) {
          this.$set(this.formData.deal_info, 'show', true)
        } else {
          this.$set(this.formData.deal_info, 'show', false)
        }
      }
      this.$forceUpdate()
    }, */
    handleChangeFromSource (data) {
      if (!this.formData || !this.formData.from_info) return

      for (let item of this.fromInfoChild) {
        if (item.id === data.fieldvalue) {
          this.formData.from_info.fieldvalue = item.id
          this.currentFrom = item.id
        }
      }
      this.relateTeamInfo(this.formData.from_info)
    },

    /**
     * 点击保存时，获取所属团队的 id
     */
    getGroupMember () {
      let { info = {} } = this.formData || {}
      let { child = [] } = info
      let groupRoleid
      let groupGroupid
      for (let item of child) {
        const { fieldkey, info: itemInfo = {} } = item
        if (fieldkey === 'group') {
          groupRoleid = itemInfo.roleid || 0
          groupGroupid = itemInfo.groupid || 0
        }
      }

      if ((this.baseinfo && this.baseinfo.system_role === 1) || !this.joinTeamCascaderShow || (groupRoleid && groupGroupid)) {
        return false
      } else {
        this.$selefToast({ type: 'error', text: this.$t('message["881"]') })
        return true
      }
    },
    /**
     * 滚动到错误的第一个地方
     */
    scrollIntoView () {
      let $scrollElement
      if (this.errorElements[0] && this.errorElements[0].previousSibling) {
        $scrollElement = this.errorElements[0].previousSibling
      } else if (this.errorElements[0]) {
        $scrollElement = this.errorElements[0]
      }
      $scrollElement && $scrollElement.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      })
    },

    async submitHandler () {
      const $memberInfoRef = this.$refs.memberInfo[0]
      let hasError = await this.validateResult()
      let memberError = $memberInfoRef && $memberInfoRef.validateMember()

      // 邮箱的校验结果是异步，数据返回来有延迟
      // 滚动到错误的第一个地方
      this.scrollIntoView()

      // 如果校验没问题提交数据
      let error = this.getGroupMember()
      if (!hasError && !error && !memberError) {
        this.handleSubmit()
      }
    },
    againSaveForm ({ checkrepeatconfirm }) {
      this.handleSubmit(checkrepeatconfirm)
    },
    async handleSubmit (checkrepeatconfirm) {
      this.$bus.$emit('myQuillEditorBlur')
      const formData = await this.setFormDataParams(this.formData)
      if (checkrepeatconfirm === 1) {
        formData.checkrepeatconfirm = checkrepeatconfirm
      }
      if (this.formHistoryId) {
        formData.info.form_history_id = this.formHistoryId
      }

      this.confirmInquiry(formData)
    },
    async confirmInquiry (formData) {
      let _this = this

      if (this.confirmLoading) return
      this.confirmLoading = true

      let chain = await addInquiry()
      chain
        .onSuccess(res => {
          console.log(res)
          this.confirmSuccess()
          // this.form.resetFields()
        })
        .onNetSuccess(raw => {
          const res = raw.data
          if (res.error === 104) { // 有重复
            this.showRepeatModal = true
            this.repeatData = res.payload
          }
          this.confirmLoading = false
        })
        .config({
          error104: false,
          tip: false,
          error100 (raw = {}) {
            // TODO: 处理后端错误
            if (raw.message) {
              _this.$selefToast({ type: 'error', text: raw.message })
            } else if (raw.payload && raw.payload.length) {
              _this.$selefToast({ type: 'error', text: raw.payload[0] })
            }
          },
          error105 (raw) {
            // TODO: 处理后端错误
            let msg = ''
            if (raw.message) {
              msg = raw.message
            } else if (raw.payload && raw.payload.length) {
              msg = raw.payload[0]
            }

            _this.$createDialog({
              type: 'alert',
              confirmBtn: {
                text: _this.$t('message["1276"]'),
                active: true
              }
            }, (createElement) => {
              return [
                createElement('div', {
                  'class': {
                    'create-inquery-upperlimit-modal-title': true
                  },
                  slot: 'title'
                }, [
                  createElement('p', _this.$t('message["1377"]'))
                ]),
                createElement('p', {
                  'class': {
                    'create-inquery-upperlimit-modal-content': true
                  },
                  slot: 'content'
                }, msg)
              ]
            }).show()
          }
        })
        .params(formData)
        .fetch()
    },
    confirmSuccess () {
      let content = ''
      if (this.isNeedAudit) {
        content = this.$t('message["167"]')
      } else {
        content = ''
      }
      this.$confirm({
        type: 'success',
        title: this.$t('message["618"]'),
        content,
        okText: this.$t('message["469"]'),
        okType: 'primary',
        cancelText: this.$t('message["284"]'),
        iconType: 'check-circle',
        centered: true,
        onOk: () => {
          this.handleCancel()
        },
        onCancel: () => {
          this.goBackList()
        }
      })
    },
    handleCancel () {
      eventBus.$emit('fetchAddConfig')
      setTimeout(() => {
        eventBus.$emit('clearCascaders', 'dev')
        eventBus.$emit('clearCascaders', 'group')
      }, 1000)
    },
    goBackList () {
      this.$router.push({
        name: 'InqueryList',
        query: {
          from: 'my',
          type: 'inquiry-add'
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  position: relative;
  padding: 0 0 90px;
  font-size: 14px;
  h2.title {
    height: 34px;
    line-height: 1;
    padding: 12px 12px 6px;
    font-size: 14px;
    color: #999;
    background-color: #f5f5f5;
  }
  .footer {
    position: fixed;
    z-index: 99;
    display: flex;
    justify-content: space-between;
    height: auto;
    padding: 8px;
    background-color: #fff;
    ::v-deep .cube-form-group-content {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
    .cube-btn {
      width: 358px;
      height: 46px;
      line-height: 46px;
      padding: 0 !important;
    }
  }
}
</style>

<style lang="scss">
.create-inquery-upperlimit-modal-title {
  padding: 24px 24px 0;
}
.create-inquery-upperlimit-modal-content {
  padding: 10px 24px 0;
}
</style>
